module.exports = __webpack_public_path__ + "img/logos_customer_08.9db27d34.svg";